angular.module('SpidApp')

.controller('ProductMultipleChoiceController',
        ['$scope', '$uibModalInstance',
function ($scope,   $uibModalInstance) {
    
    $scope.cancel = function () {
		$uibModalInstance.dismiss('cancel')
	}
    
    $scope.selectProduct = function (product) {
        $uibModalInstance.close(product)
    }
    
}])